





























































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {SelectOption} from "@/util/selectOption";

type VehicleCost = {
    value: number;
    co2: number;
}

type PurchasedVehicle = {
    didPurchaseVehicleThisYear: boolean;
    percentOfTimeUsedForWork: number;
    vehicleValue?: number;
}

@Component
export default class VehicleDetailsForm extends Vue {

    @Prop()
    formEndpoint!: string;

    @Prop()
    previousStepHref!: string;

    @Prop({
        default: []
    })
    vehicles!: VehicleCost[];

    @Prop()
    purchasedVehicle!: PurchasedVehicle;

    @Prop({
        default: null
    })
    percentOfTimeVehicleUsedForWork!: number | null;

    private vehicleCosts: VehicleCost[] = this.vehicles;

    @Prop()
    mileageAllowanceCarDetails!: string | null;

    @Prop()
    mileageAllowanceMotorbikeDetails!: string | null;

    @Prop()
    isClaimingVehicleDepreciationProp!: boolean;

    private numberOfVehicles: number = this.vehicleCosts.length;
    private loading: boolean = false;
    private maxVehicleClaimCount = 9;
    private vehicleTimeUseOption: SelectOption | null = null;

    private didPurchaseVehicleThisYear: boolean = this.purchasedVehicle.didPurchaseVehicleThisYear;
    private newVehicleTimeUseOption: SelectOption | null = null;
    private purchasedVehicleValue: number = this.purchasedVehicle.vehicleValue ?? 0;
    private isClaimingVehicleDepreciation: boolean = this.isClaimingVehicleDepreciationProp

    private mounted() {
        if (this.percentOfTimeVehicleUsedForWork) {
            this.vehicleTimeUseOption = {
                id: this.percentOfTimeVehicleUsedForWork,
                name: `${this.percentOfTimeVehicleUsedForWork}%`
            }
        }

        if (this.didPurchaseVehicleThisYear) {
            this.newVehicleTimeUseOption = {
                id: this.purchasedVehicle.percentOfTimeUsedForWork,
                name: `${this.purchasedVehicle.percentOfTimeUsedForWork}%`
            }
        }
    }

    private get vehicleTimeUseOptions(): SelectOption[] {
        const options: SelectOption[] = [];
        for (let i = 5; i <= 100; i+=5) {
            options.push({
                id: i,
                name: `${i}%`
            })
        }
        return options;
    }

    private get hasMileageAllowanceCar(): boolean {
        return this.mileageAllowanceCarDetails !== null && this.mileageAllowanceCarDetails.length > 0;
    }

    private get hasMileageAllowanceMotorbike(): boolean {
        return this.mileageAllowanceMotorbikeDetails !== null && this.mileageAllowanceMotorbikeDetails.length > 0;
    }

    private get hasMileageAllowance(): boolean {
        return this.hasMileageAllowanceCar || this.hasMileageAllowanceMotorbike;
    }

    @Watch('numberOfVehicles')
    private onNumberOfVehiclesChanged(newNumber: number) {
        const currentNumber = this.vehicleCosts.length;
        if (newNumber < currentNumber) {
            while (this.vehicleCosts.length !== newNumber) {
                this.vehicleCosts.pop()
            }
        } else if (newNumber > currentNumber) {
            while (this.vehicleCosts.length !== newNumber) {
                this.vehicleCosts.push({
                    value: 0,
                    co2: 0
                });
            }
        }
    }
}
